import { useCallback } from "react";

import { useMarketingCampaignFormModelContext } from "../../../../context";

export const useCampaignDescription = () => {
	const { viewModel, onSetViewModel } = useMarketingCampaignFormModelContext();

	const { description } = viewModel;

	const onSetDescription = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "description", value: { ...description, value: input } }]);
		},
		[description, onSetViewModel],
	);

	return {
		description,
		onSetDescription,
	};
};
